import { render, staticRenderFns } from "./attachments-tab.vue?vue&type=template&id=d3cd7b9c&"
import script from "./attachments-tab.vue?vue&type=script&lang=js&"
export * from "./attachments-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports